import { Link } from 'react-router-dom';

interface PlayCtaButtonProps {
  label?: string;
  className?: string;
  size?: 'default' | 'lg';
}

/// Landing-page call to action. Sends players to the guest Start screen
/// (`/signup`) where they pick a username and play immediately as an anonymous
/// user on the free starter gift — no email/password until they save their
/// account later from the dashboard.
export default function PlayCtaButton({
  label = 'Start Playing Free',
  className = '',
  size = 'default',
}: PlayCtaButtonProps) {
  const sizing = size === 'lg' ? 'px-12 py-4 text-lg' : 'px-8 py-3 text-sm';
  return (
    <Link
      to="/signup"
      className={`inline-flex items-center justify-center rounded-md ${sizing} font-medium text-white uppercase tracking-wide transition-colors whitespace-nowrap hover:opacity-90 ${className}`}
      style={{ backgroundColor: 'hsl(var(--accent-gold))' }}
    >
      {label}
    </Link>
  );
}
